import { api } from 'data/api/api'

import { BrandsResp } from './types/brand'

type GetPopularBrandsArgs = {
  letter?: string
}

export const getPopularBrands = ({ letter }: GetPopularBrandsArgs = {}) =>
  api.get<BrandsResp>('/brands/popular', {
    params: {
      letter,
    },
  })

type ToggleBrandFollowResp = {
  is_followed: boolean
}

type ToggleBrandFollowArgs = {
  brandId: number
}

export const toggleBrandFollow = ({ brandId }: ToggleBrandFollowArgs) =>
  api.post<ToggleBrandFollowResp>('/brands/toggle_follow', {
    brand_id: brandId,
  })
